import { get, Keys } from '~/util/sessionStorage'

const getBasketFromStore = () => {
  const flatBasket = get(Keys.BASKET, '')
  if (flatBasket) {
    const basket = JSON.parse(flatBasket)

    return {
      basket,
    }
  }
  return {}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadState = (): any => ({
  ...getBasketFromStore(),
})
